import React from "react"

import { DesktopWrapper, Table } from "../styles/Table.styled"

import TableHeader from "./Header/TableHeader"
import PackageTableSection from "./PackageTableSection"

const DesktopTable = ({ component, isTableNavSticky }) => {
  const { packageTableSections } = component

  return (
    <DesktopWrapper>
      <Table>
        <TableHeader
          component={component}
          isTableNavSticky={isTableNavSticky}
        />
        {packageTableSections.length > 0 &&
          packageTableSections?.map((packageTableSection) => {
            return (
              <PackageTableSection
                key={packageTableSection?.id}
                sectionTitle={packageTableSection?.sectionTitle}
                sectionRows={packageTableSection?.sectionRows}
              />
            )
          })}
      </Table>
    </DesktopWrapper>
  )
}

export default DesktopTable
